import useLocalStorage from "./useLocalStorage"

export interface OTPRateLimitState {
    codeVerificationId: string
    sentAt: number // Unix timestamp ms
    checkFor: "email" | "phone"
    contactValue: string // email or phone used
}

const OTP_COOLDOWN_MS = 30 * 1000 // 30 seconds

function isStateValid(state: OTPRateLimitState | null, checkFor: "email" | "phone", contactValue: string): boolean {
    if (!state) {
        return false
    }
    if (state.checkFor !== checkFor) {
        return false
    }
    if (state.contactValue !== contactValue) {
        return false
    }

    const elapsedMs = Date.now() - state.sentAt
    return elapsedMs < OTP_COOLDOWN_MS
}

function getRemainingCooldownSeconds(sentAt: number): number {
    const elapsedMs = Date.now() - sentAt
    const remainingMs = OTP_COOLDOWN_MS - elapsedMs
    return Math.max(0, Math.ceil(remainingMs / 1000))
}

export default function useOTPRateLimit(storageKey: string) {
    const [state, setState] = useLocalStorage<OTPRateLimitState | null>(storageKey, null)

    const isWithinCooldown = state !== null && Date.now() - state.sentAt < OTP_COOLDOWN_MS

    const isValid = (checkFor: "email" | "phone", contactValue: string): boolean => {
        return isStateValid(state, checkFor, contactValue)
    }

    const getRemainingSeconds = (): number => {
        if (!state) {
            return 30
        }
        return getRemainingCooldownSeconds(state.sentAt)
    }

    const clearState = () => {
        setState(null)
    }

    return {
        state,
        setState,
        isValid,
        isWithinCooldown,
        getRemainingSeconds,
        clearState,
    }
}
